import PropTypes from "prop-types"
// @mui
import { Box, List } from "@mui/material"
//
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { hasDemand } from "lib/authorization/has-demand"
import { useCurrentUser } from "lib/store/use-current-user"
import { WhoAmI } from "minimals-template/components/nav-section/vertical/who-am-i"
import NavGroup from "./nav-group"

// ----------------------------------------------------------------------

NavSectionVertical.propTypes = {
    isCollapse: PropTypes.bool,
    navConfig: PropTypes.array,
}

export default function NavSectionVertical({ navConfig, isCollapse, ...other }) {
    const user = useCurrentUser()
    const showWhoAmI = hasDemand("$sharing") || !!user.isOverridingClient

    return (
        <Box component="nav" aria-label="Main" {...other}>
            <If value={showWhoAmI}>
                <WhoAmI />
            </If>
            <List component="ul" role="list" disablePadding sx={{ px: 2 }}>
                <Repeat list={navConfig} item={<NavGroup isCollapse={isCollapse} />} pass="group" keyFn={byGroupKey} />
            </List>
        </Box>
    )

    function byGroupKey(group) {
        return group.group ?? "ungrouped"
    }
}
